import commonEndpoints from 'config/api/common';
import { ContentType } from 'config/api/selfTests/_types';
import general_messages from 'messages/general_messages';

type Tag = {
  id: string;
  name: string;
};

const prepareTags = ({ tags }: { tags: Tag[] }) => tags.map(tag => ({ id: tag.name, name: tag.name.toLowerCase() }));

const getTagFilter = (contentType?: Exclude<ContentType, 'incident_guide'>) => ({
  url: commonEndpoints.tags(contentType ? { content_type: contentType } : undefined),
  // TODO type it
  dataParser: (data: any, result: any) => ({
    ...result,
    tags: { sectionName: general_messages.tags, filters: prepareTags(data) },
  }),
});

export default getTagFilter;
